'use client';

import React from "react";
import Image from '@src/components/atoms/safe-image';
import * as Yup from "yup";
import { useFormik } from "formik";

// Assets
import XIcon from '@public/png/x-1.png';
import Magnifying from "@public/png/magnifying-1.png"
import InfoIcon from "@public/png/info-1.png"

// Components
import Modal from '@src/components/atoms/modal'
import Button from '@src/components/atoms/button'
import TextInput from "../form/text-input";

const phoneRegExp = /^08\d{8,11}$/;

const validationSchema = Yup.object({
  province: Yup.string().required("Provinsi wajib diisi"),
  city: Yup.string().required("Area/Kota wajib diisi"),
  phone: Yup.string().required("Area/Kota wajib diisi").matches(phoneRegExp, "Nomor HP tidak valid. Pastikan diawali dengan 08 dan terdiri dari 10-13 digit")
});

const ModalTanyaMarketing = ({ onClose, onHelp, ...props }) => {
  const formik = useFormik({
    initialValues: {
      province: "",
      city: "",
      phone: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Form values:", values);
    },
  });

  return (
    <Modal {...props} onClose={onClose} className="!items-start dd2-xl:hidden">
      <form onSubmit={formik.handleSubmit} className='relative mt-[56px] z-[42] w-[460px] rounded-[12px] bg-white p-4'>
        <button className='absolute z-[43] p-1 -top-8 right-0 flex justify-center items-center bg-white rounded-[40px]'>
          <Image
            width={16}
            height={16}
            src={XIcon}
            alt='Close'
            className='object-contain'
            onClick={onClose}
          />
        </button>

        <p className='text-22 font-sfpro-bold mb-2'>Cek ketersediaan properti</p>
        <p className='text-17 text-[#808285] mb-4'>Tanya marketing kami untuk melihat apakah ada properti yang Anda inginkan di area/kota tersebut.</p>

        <div className="bg-[#F6F6F6] rounded-[12px] p-4 mb-2">
          <TextInput
            required
            label="Provinsi"
            name="province"
            value={formik.values.province}
            placeholder="Masukkan provinsi"
            onChange={formik.handleChange}
            error={formik.touched.province ? formik.errors.province : ""}
            className={`border rounded-lg p-2 w-full ${formik.touched.province && formik.errors.province ? "border-red-500" : "border-gray-300"
              }`}
          />
          <TextInput
            required
            label="Area/Kota yang tidak ditemukan"
            placeholder="Masukkan area/kota"
            name="city"
            onChange={formik.handleChange}
            value={formik.values.city}
            error={formik.touched.city ? formik.errors.city : ""}
            className={`border rounded-lg p-2 w-full ${formik.touched.city && formik.errors.city ? "border-red-500" : "border-gray-300"
              }`} />
          <TextInput
            required
            label="Nomor WhatsApp Aktif"
            placeholder="08123456789"
            name="phone"
            onChange={formik.handleChange}
            value={formik.values.phone}
            error={formik.touched.phone ? formik.errors.phone : ""}
            className={`border rounded-lg p-2 w-full ${formik.touched.phone && formik.errors.phone ? "border-red-500" : "border-gray-300"
              }`} />

          <div className="flex items-start">
            <Image
              src={InfoIcon}
              alt='Info Icon'
              width="auto"
              height="auto"
              className='mt-0.5 w-4 h-4 cursor-pointer object-contain mr-1.5'
            />
            <p className="text-13 text-[#808285]">Kami akan merespon permintaan Anda dalam beberapa hari ke depan via WhatsApp. Pastikan nomor yang dimasukkan adalah nomor WhatsApp aktif.</p>
          </div>
        </div>

        <div className="flex items-center justify-end">
          <button onClick={onHelp} type="button" className='text-17 mr-4 font-sfpro-semibold underline'>Batal</button>
          <Button
            disabled={formik.isSubmitting || !formik.isValid}
            type="submit">Tanya Marketing</Button>
        </div>
      </form>
    </Modal>
  )
}

const ModalTanyaMarketingMobile = ({ onClose, onHelp, ...props }) => {
  const formik = useFormik({
    initialValues: {
      province: "",
      city: "",
      phone: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Form values:", values);
    },
  });

  return (
    <Modal {...props} onClose={onClose} className="!items-start hidden dd2-xl:flex">
      <form onSubmit={formik.handleSubmit} className='z-[42] w-screen h-screen bg-white p-4 overflow-y-auto'>
        <div className="h-full flex flex-col justify-between">
          <div>
            <div className='flex items-center justify-end mb-4 pb-4'>
              <span className='text-17 text-[#808285]'>Bantuan</span> {">"} <span className='text-17'>Tanya Marketing</span>
            </div>

            <p className='text-22 font-sfpro-bold mb-2'>Cek ketersediaan properti</p>
            <p className='text-17 text-[#808285] mb-4'>Tanya marketing kami untuk melihat apakah ada properti yang Anda inginkan di area/kota tersebut.</p>

            <div className="bg-[#F6F6F6] rounded-[12px] p-4 mb-2">
              <TextInput
                required
                label="Provinsi"
                name="province"
                value={formik.values.province}
                placeholder="Masukkan provinsi"
                onChange={formik.handleChange}
                error={formik.touched.province ? formik.errors.province : ""}
                className={`border rounded-lg p-2 w-full ${formik.touched.province && formik.errors.province ? "border-red-500" : "border-gray-300"
                  }`}
              />
              <TextInput
                required
                label="Area/Kota yang tidak ditemukan"
                placeholder="Masukkan area/kota"
                name="city"
                onChange={formik.handleChange}
                value={formik.values.city}
                error={formik.touched.city ? formik.errors.city : ""}
                className={`border rounded-lg p-2 w-full ${formik.touched.city && formik.errors.city ? "border-red-500" : "border-gray-300"
                  }`} />
              <TextInput
                required
                label="Nomor WhatsApp Aktif"
                placeholder="08123456789"
                name="phone"
                onChange={formik.handleChange}
                value={formik.values.phone}
                error={formik.touched.phone ? formik.errors.phone : ""}
                className={`border rounded-lg p-2 w-full ${formik.touched.phone && formik.errors.phone ? "border-red-500" : "border-gray-300"
                  }`} />

              <div className="flex items-start">
                <Image
                  src={InfoIcon}
                  alt='Info Icon'
                  width="auto"
                  height="auto"
                  className='mt-0.5 w-4 h-4 cursor-pointer object-contain mr-1.5'
                />
                <p className="text-13 text-[#808285]">Kami akan merespon permintaan Anda dalam beberapa hari ke depan via WhatsApp. Pastikan nomor yang dimasukkan adalah nomor WhatsApp aktif.</p>
              </div>
            </div>

          </div>
        </div>

        <div className="flex items-center justify-end">
          <button onClick={onHelp} type="button" className='text-17 mr-4 font-sfpro-semibold underline'>Batal</button>
          <Button
            disabled={formik.isSubmitting || !formik.isValid}
            type="submit">Tanya Marketing</Button>
        </div>
      </form>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null
  return (
    <>
      <ModalTanyaMarketing isOpen={isOpen} {...props} />
      <ModalTanyaMarketingMobile isOpen={isOpen} {...props} />
    </>
  )
}

export default Wrapper